import { useEffect, useState } from 'react';
import { createReportFromWork } from '../api';

interface UseWorkIdInitializationResult {
  isCreatingFromWork: boolean;
  error: string | null;
}

export const useWorkIdInitialization = (
  workId: string | null,
  reportId: number | null,
  setReportId: (reportId: string | null) => void,
): UseWorkIdInitializationResult => {
  const [isCreatingFromWork, setIsCreatingFromWork] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Only run if we have a workId and no reportId
    if (!workId || reportId) {
      return;
    }

    const initializeFromWork = async () => {
      setIsCreatingFromWork(true);
      setError(null);

      try {
        const data = await createReportFromWork(workId);

        // Update URL with the new report_id
        if (data.report?.report_id) {
          setReportId(data.report.report_id.toString());
        }
      } catch (err) {
        const errorMessage =
          err instanceof Error
            ? err.message
            : 'Failed to create report from work';
        setError(errorMessage);
      } finally {
        setIsCreatingFromWork(false);
      }
    };

    initializeFromWork();
  }, [workId, reportId, setReportId]);

  return {
    isCreatingFromWork,
    error,
  };
};
